export default __webpack_public_path__ + "static/media/icn-close.5ee3a043.svg";